// UniversalTable.jsx
import React from "react";
import styles from "./UniversalTable.module.css";

// Универсальный компонент таблицы
const UniversalTable = ({ headers, rows, onEdit, onDelete, onCopy }) => {
  const accentColor = "#7faac3";

  // Иконки для действий
  const EditIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  );

  const DeleteIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M3 6h18"></path>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <path d="M10 11v6"></path>
      <path d="M14 11v6"></path>
    </svg>
  );

  const CopyIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect
        x="9"
        y="9"
        width="13"
        height="13"
        rx="2"
        ry="2"
      ></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  );

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tableHeader}>
            {headers.map((header, index) => (
              <th
                key={index}
                className={styles.headerCell}
              >
                {header}
              </th>
            ))}
            <th className={styles.actionsHeader}>Действия</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}
            >
              {Object.values(row).map((value, colIndex) => (
                <td
                  key={colIndex}
                  className={styles.dataCell}
                >
                  {value}
                </td>
              ))}
              <td className={styles.actionsCell}>
                <button
                  onClick={() => onEdit && onEdit(row)}
                  className={styles.actionButton}
                  title="Изменить"
                >
                  <EditIcon />
                </button>
                <button
                  onClick={() => onDelete && onDelete(row)}
                  className={`${styles.actionButton} ${styles.deleteButton}`}
                  title="Удалить"
                >
                  <DeleteIcon />
                </button>
                <button
                  onClick={() => onCopy && onCopy(row)}
                  className={styles.actionButton}
                  title="Скопировать ссылку"
                >
                  <CopyIcon />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UniversalTable;
